<style lang="scss" scoped>
.tooltip {
    display: block !important;
    z-index: 10000;

    .tooltip-inner {
        background: black;
        color: white;
        border-radius: 16px;
        padding: 5px 10px 4px;
    }

    .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: black;
        z-index: 1;
    }

    &[x-placement^="top"] {
        margin-bottom: 5px;

        .tooltip-arrow {
            border-width: 5px 5px 0 5px;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            bottom: -5px;
            left: calc(50% - 5px);
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    &[x-placement^="bottom"] {
        margin-top: 5px;

        .tooltip-arrow {
            border-width: 0 5px 5px 5px;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-top-color: transparent !important;
            top: -5px;
            left: calc(50% - 5px);
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    &[x-placement^="right"] {
        margin-left: 5px;

        .tooltip-arrow {
            border-width: 5px 5px 5px 0;
            border-left-color: transparent !important;
            border-top-color: transparent !important;
            border-bottom-color: transparent !important;
            left: -5px;
            top: calc(50% - 5px);
            margin-left: 0;
            margin-right: 0;
        }
    }

    &[x-placement^="left"] {
        margin-right: 5px;

        .tooltip-arrow {
            border-width: 5px 0 5px 5px;
            border-top-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            right: -5px;
            top: calc(50% - 5px);
            margin-left: 0;
            margin-right: 0;
        }
    }

    &.popover {
        $color: #f9f9f9;

        .popover-inner {
            background: $color;
            color: black;
            padding: 24px;
            border-radius: 5px;
            box-shadow: 0 5px 30px rgba(black, 0.1);
        }

        .popover-arrow {
            border-color: $color;
        }
    }

    &[aria-hidden="true"] {
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.15s, visibility 0.15s;
    }

    &[aria-hidden="false"] {
        visibility: visible;
        opacity: 1;
        transition: opacity 0.15s;
    }
}
::v-deep .table-row {
    background: #fff;
}
</style>

<template>
    <div v-if="workspace" class="el-users">

        <workspace-layout v-if="workspace && workspace.permissions && workspace.permissions.can_edit">

            <template v-slot:breadcrumbs>
                <el-breadcrumbs :canEdit="false" :showCrumb="true" :parents="[]" :current="{ title: $t(`${$options.name}.title`) }"></el-breadcrumbs>
            </template>

            <template v-slot:actions v-if="!$root.isMobile">
                <button v-if="selectedUsers.length > 0" :disabled="loading" href="javascript:void(0)" @click.prevent="removeUser" class="btn btn-outline-danger d-flex">
                    <i class="fal fa-trash mr-15 my-auto"></i>
                    <span class="my-auto" v-html="$t(`${$options.name}.remove`)"></span>
                </button>

                <button :disabled="loading" @click.prevent="addUser" class="btn btn-outline-primary ml-15 d-flex">
                    <i class="fal fa-plus mr-15 my-auto"></i>
                    <span class="my-auto" v-html="$t(`${$options.name}.add`)"></span>
                </button>

                <button :disabled="loading" @click.prevent="inviteUser" class="btn btn-primary ml-15 d-flex">
                    <i class="fal fa-plus mr-15 my-auto"></i>
                    <span class="my-auto" v-html="$t(`${$options.name}.invite`)"></span>
                </button>
            </template>

            <template v-slot:page>
                <div class="row position-relative">
                    <el-error class="col-12 mt-30" :error="server_error"></el-error>
                    <vue-good-table class="col-12 mt-30" :columns="columns" :search-options="{ enabled : false }" :rows="users" @on-selected-rows-change="selectionChanged" :select-options="{ enabled: true }" styleClass="vgt-table light-table">
                        <template slot="table-row" slot-scope="slotProps">
                            <span v-if="slotProps.column.field === 'admin'" @click.stop>
                                <div class="d-flex align-items-center">
                                    <div class="custom-control custom-checkbox d-inline-block" :data-tooltip="slotProps.row.id === user.id ? $t(`${$options.name}.cant_change_own_role`) : slotProps.row.is_workspace_owner ? $t(`${$options.name}.owners_are_always_admin`) : false">
                                        <input :disabled="slotProps.row.id === user.id || slotProps.row.is_workspace_owner || !!slotProps.row.read_only" @change="handleUserRoleUpdated(slotProps.row)" type="checkbox" class="custom-control-input" :id="`${slotProps.row.id}_adminCheckbox`" v-model="slotProps.row.is_workspace_admin">
                                        <label class="custom-control-label" :for="`${slotProps.row.id}_adminCheckbox`">
                                            <span class="sr-only">{{ (slotProps.row.is_workspace_admin) ? 'Yes' : 'No' }}</span>
                                        </label>
                                    </div>
                                    <span v-if="slotProps.row.is_workspace_owner">{{ $t(`${$options.name}.owner`) }}</span>
                                </div>
                            </span>
                            <span v-else-if="slotProps.column.field === 'containers'" class="d-flex flex-row align-contents-center">
                                <div class="tags row" style="margin-left: -1.5px; margin-right: -1.5px;">
                                    <div class="col-auto" style="padding-left: 1.5px; padding-right: 1.5px;" v-for="(tag, index) in slotProps.row.containers" :key="index">
                                        <div class="tag small bg-primary text-white rounded px-5 py-3 mb-3">{{ tag }}</div>
                                    </div>
                                </div>
                            </span>
                            <span v-else-if="slotProps.column.field === 'user'" class="d-flex flex-row align-contents-center">
                                <el-avatar class="my-auto" :user="slotProps.row"></el-avatar>
                                <p class="my-auto ml-8"> {{ slotProps.row.first_name }} {{ slotProps.row.last_name }} </p>
                            </span>
                            <span v-else>
                                {{ slotProps.formattedRow[slotProps.column.field] }}
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </template>

        </workspace-layout>

    </div>
</template>

<script>
import WorkspaceLayout from "@/layouts/workspace";

import { ElBreadcrumbs, ElAvatar } from "@/components/elements/_index";

import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';

import InvitePopup from "@/popups/general/invite";
import UserRemovePopup from "@/popups/user/remove";
import UserAddPopup from "@/popups/user/add";

import HasForm from '@/components/forms/has-form';

export default {
    name: 'views.workspace.users',

    components: {
        ElError: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElError"),
        WorkspaceLayout, VueGoodTable, ElBreadcrumbs, ElAvatar
    },

    mixins: [HasForm],

    data() {
        return {
            selectedUsers: [],
            columns: [
                { width: '250px', label: this.$t('forms.labels.user'), field: 'user', sortable: true, sortFn: this.userSort },
                { width: '300px', label: this.$t('forms.labels.email'), field: 'email' },
                { width: '200px', label: this.$t('forms.labels.last_activity'), field: 'last_activity', type: 'date', dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSSSS\'Z\'', dateOutputFormat: 'PP', thClass: 'text-left', tdClass: 'text-left' },
                { width: '200px', label: this.$t('forms.labels.boards'), field: 'containers', sortable: false },
                { width: '200px', label: this.$t('forms.labels.admin_permissions'), field: 'admin', sortable: false },
                { field: this.$t('forms.labels.lastname'), hidden: true },
                { field: this.$t('forms.labels.firstname'), hidden: true }
            ],
        };
    },

    mounted() {
        this.$store.dispatch('workspace/readUsers', this.workspace.id)
    },

    methods: {

        selectionChanged(changes) {
            this.selectedUsers = changes.selectedRows.map(u => u.id)
        },

        userSort(x, y, col, rowX, rowY) {
            var aFirstChar = rowX.first_name.charAt(0);
            var bFirstChar = rowY.first_name.charAt(0);
            if (aFirstChar > bFirstChar) {
                return 1;
            } else if (aFirstChar < bFirstChar) {
                return -1;
            } else {
                var aLastChar = rowX.last_name.charAt(0);
                var bLastChar = rowY.last_name.charAt(0);
                if (aLastChar > bLastChar) {
                    return 1;
                } else if (aLastChar < bLastChar) {
                    return -1;
                } else {
                    return 0;
                }
            }
        },

        inviteUser() {
            this.$modal.show(InvitePopup, { type: 'workspace', modelId: this.workspace.id }, { adaptive: true, height: 'auto', width: '600', scrollable: true })
        },

        removeUser() {
            let users = this.users.filter(u => !this.selectedUsers.includes(u.id)).map(u => { return { id: u.id, is_workspace_admin: u.is_workspace_admin } })
            this.$modal.show(UserRemovePopup, { type: 'workspace', users: users, modelCount: this.selectedUsers.length, modelTitle: this.workspace.company, modelId: this.workspace.id }, { adaptive: true, height: 'auto', width: '400' })
        },

        addUser() {
            this.$modal.show(UserAddPopup, { workspaceId: this.workspace.id }, { adaptive: true, height: 'auto', width: '600' })
        },

        handleUserRoleUpdated(user) {
            this.beforeSubmit()
            this.$store.dispatch('workspace/updateUser', { workspace_id: this.workspace.id, user })
                .then(res => {
                    this.users = res.reverse()
                    this.handleSuccess()
                }).catch(e => this.handleError(e))
        },
    },

    computed: {
        user() {
            return this.$store.getters['auth/user']
        },
        users() {
            return this.$store.getters['workspace/users']
        },
        workspace() {
            return this.$store.getters['workspace/current']
        }
    },
};
</script>
